import React, { memo } from 'react';

const ValueListsIcon = ({ color = '#788590' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <g fill={color} fillRule="evenodd">
                <rect width="16" height="4" x="1" y="2" rx="2" />
                <rect width="16" height="4" x="1" y="7" rx="2" />
                <rect width="16" height="4" x="1" y="12" rx="2" />
            </g>
        </svg>
    );
};

export default memo(ValueListsIcon);
